import { CaretDownOutlined } from "@ant-design/icons";
import { Picker } from "antd-mobile";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";

const FilterTypeDropdownSelect = ({
  required = false,
  title = "",
  options = [],
  value = [],
  columns = 3,
  setValue = () => {},
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const onSelectChange = (value) => {
    // console.log('value', value)
    if (value.length) {
      setValue(value[0]);
    } else {
      if (required === false) {
        setValue(null);
      }
    }
  };
  const findLabel = () => {
    // console.log('value', value)
    if (options?.length > 0) {
      const found = options.find((item) => item.value === value[0]);
      if (found) return found.label;
      return "";
    }
  };

  return (
    <div className={`${styles.container} filter-dropdown-select`}>
      <div className={`${styles.title}`}>{title}</div>
      <Picker
        confirmText={t("normal.confirm")}
        cancelText={t("normal.cancel")}
        columns={[options]}
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        value={value}
        onConfirm={onSelectChange}
        onSelect={(val, extend) => {
          // console.log('onSelect', val, extend.items)
        }}
        mouseWheel={true}
      />
      <div
        className={`${styles.selectButton}`}
        onClick={() => {
          setVisible(true);
        }}
      >
        {findLabel()}
        <CaretDownOutlined rotate={visible ? 180 : 0} style={{ fontSize: "16px" }} />
      </div>
    </div>
  );
};

export default FilterTypeDropdownSelect;
